<template>
  <div class="group">
    <div class="header"><span>公告</span></div>
    <div class="body">
      <h2>太原赛事沟通群</h2>
      <p class="sub-title"><span>2025-05-14</span><span>发布人：贾学云</span></p>
      <div class="content">
        <p>请各位参赛选手务必微信扫码进群，后续大赛有相关文件和动态将在群里通知。</p>
        <p><img src="https://www.ttcdw.com.cn/storage/group1/M00/2C/75/CgoAGGiG9quAIY1PAAJgCk_HDKE922.jpg" title=""
            alt="imgFile-64f9963b9234ae2ae0f2452b18aed076.jpg" width="358" height="432"></p>
      </div>
    </div>
  </div>
</template>


<script>

export default {
  props: {
    step: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {

    }
  },
  components: {

  },
  created() {

  },
  mounted() {
    document.title = '山西省第四届家庭教育指导技能大赛报名'
  },
  computed: {

  },
  methods: {


  },

}
</script>
<style lang="scss" scoped>
.group {
 margin-top: 10px;
  width: 100%;
  height: 100%;

  .header {
    padding: 15px 30px;
    border-bottom: 1px solid #d9d9d9;
    box-shadow: 0 1px 0 #f2f2f2;

    span {
      padding: 0 10px;
      color: #666;
      font-size: 16px;
      display: inline-block;
      line-height: 40px;
      margin: 0 20px 0 0;
    }
  }

  .body {
    margin: 30px 0 0 0;
    padding: 0 40px 40px 40px;

    h2 {
      font-size: 20px;
      font-weight: 700;
      text-align: center;
      color: #666;
      margin: 0;
    }

    .sub-title {
      text-align: center;
      line-height: 19px;
      margin: 15px 0 30px;

      span {
        font-size: 15px;
        color: #999;
        margin: 0 20px 0 0;
      }
    }

    .content {
      margin: 50px 0 0 0;

      p {
        font-size: 16px;
        color: #666;
        text-align: left;
        line-height: 24px;
        margin: 13px 0 0;

        img {
          max-width: 100%;
        }
      }
    }
  }

}
</style>
